export const servicesDataFour = [
    {
        id: '01',
        service_name: "Security Management",
        service_details: "The Imperative of Cybersecurity in an Interconnected World.",
        link: "/service-details"
    },
    {
        id: '02',
        service_name: "Data Privacy",
        service_details: "The Imperative of Cybersecurity in an Interconnected World.",
        link: "/service-details"
    },
    {
        id: '03',
        service_name: "Network Security",
        service_details: "The Imperative of Cybersecurity in an Interconnected World.",
        link: "/service-details"
    },
    {
        id: '04',
        service_name: "DDOS Protection",
        service_details: "The Imperative of Cybersecurity in an Interconnected World.",
        link: "/service-details"
    },

]